import React from 'react';
import { useIntl } from 'react-intl';
import { Option as SelectOption, Select } from 'carbon-react/lib/components/select';
import Box from 'carbon-react/lib/components/box';

import { RecurrenceWeekDay } from './types';

interface WeekDaySelectProps {
  value: RecurrenceWeekDay;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const WeekDaySelect = ({ value, onChange }: WeekDaySelectProps) => {
  const intl = useIntl();

  return (
    <Box mb="16px" display="flex" alignItems="center">
      <Select
        required
        label={intl.formatMessage({ id: 'common.on_day_name', defaultMessage: 'On' })}
        value={value}
        onChange={onChange}
        mb="0"
        size="medium"
        style={{ width: 140 }}
      >
        <SelectOption
          value={RecurrenceWeekDay.MONDAY}
          text={intl.formatMessage({ id: 'common.monday', defaultMessage: 'Monday' })}
        />
        <SelectOption
          value={RecurrenceWeekDay.TUESDAY}
          text={intl.formatMessage({ id: 'common.tuesday', defaultMessage: 'Tuesday' })}
        />
        <SelectOption
          value={RecurrenceWeekDay.WEDNESDAY}
          text={intl.formatMessage({ id: 'common.wednesday', defaultMessage: 'Wednesday' })}
        />
        <SelectOption
          value={RecurrenceWeekDay.THURSDAY}
          text={intl.formatMessage({ id: 'common.thursday', defaultMessage: 'Thursday' })}
        />
        <SelectOption
          value={RecurrenceWeekDay.FRIDAY}
          text={intl.formatMessage({ id: 'common.friday', defaultMessage: 'Friday' })}
        />
        <SelectOption
          value={RecurrenceWeekDay.SATURDAY}
          text={intl.formatMessage({ id: 'common.saturday', defaultMessage: 'Saturday' })}
        />
        <SelectOption
          value={RecurrenceWeekDay.SUNDAY}
          text={intl.formatMessage({ id: 'common.sunday', defaultMessage: 'Sunday' })}
        />
      </Select>
    </Box>
  );
};
